import { formURL } from "Utils/CommonUtilities";
import BaseApiUploadRequest from "./BaseApiUploadRequest";
import { ADD_DOCUMENT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class AddDocument extends BaseApiUploadRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = ADD_DOCUMENT_URL;

  constructor(applicationId, productId, payLoad) {
    super();
    this.body = payLoad;
    const paramList = [applicationId, productId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
